import { Button, Modal } from "antd";
import "./style.scss";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getInfo, getRaioXPaciente } from "./action";
import CardGrid from "./components/CardGrid";
import { BarLoader } from "react-spinners";

const RaioXModal = ({ onClose, open, paciente }) => {
  const [infos, setInfos] = useState();
  const [nome, setNome] = useState();
  const fetchRaioXInfos = async () => {
    const response = await getRaioXPaciente(paciente);
    setInfos(response);
  };
  const fetchNome = async () => {
    const {nome} = await getInfo(paciente);
    setNome(nome);
  };
  useEffect(() => {
    if (paciente && open) fetchNome();
    if (paciente && open) fetchRaioXInfos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paciente, open]);

  return (
    <Modal
      title={
        <span style={{ color: "#0F79B2", fontWeight: "bold" }}>
          Raio-X do Paciente
        </span>
      }
      destroyOnClose
      bodyStyle={{ height: "calc(90vh - 100px)", overflow: "auto" }}
      centered
      style={{ minWidth: "70vw", overflowY: "hidden" }}
      visible={open}
      onCancel={onClose}
      footer={[
        <Button key="submit" type="primary" onClick={onClose}>
          Fechar
        </Button>,
      ]}
    >
      <div className="tags">
        <span className="tag">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.0013 5.9834C5.26797 5.9834 4.66797 5.75007 4.2013 5.2834C3.73464 4.81673 3.5013 4.21673 3.5013 3.4834C3.5013 2.75007 3.73464 2.15007 4.2013 1.6834C4.66797 1.21673 5.26797 0.983398 6.0013 0.983398C6.73464 0.983398 7.33464 1.21673 7.8013 1.6834C8.26797 2.15007 8.5013 2.75007 8.5013 3.4834C8.5013 4.21673 8.26797 4.81673 7.8013 5.2834C7.33464 5.75007 6.73464 5.9834 6.0013 5.9834ZM1.66797 11.3334C1.39019 11.3334 1.15408 11.2362 0.959635 11.0417C0.765191 10.8473 0.667969 10.6112 0.667969 10.3334V9.76673C0.667969 9.34451 0.773524 8.9834 0.984635 8.6834C1.19575 8.3834 1.46797 8.15562 1.8013 8.00007C2.54575 7.66673 3.25964 7.41673 3.94297 7.25007C4.6263 7.0834 5.31241 7.00007 6.0013 7.00007C6.69019 7.00007 7.37352 7.08618 8.0513 7.2584C8.72908 7.43062 9.44019 7.67784 10.1846 8.00007C10.5291 8.15562 10.8069 8.3834 11.018 8.6834C11.2291 8.9834 11.3346 9.34451 11.3346 9.76673V10.3334C11.3346 10.6112 11.2374 10.8473 11.043 11.0417C10.8485 11.2362 10.6124 11.3334 10.3346 11.3334H1.66797Z"
              fill="#888888"
            />
          </svg>
          {nome}
        </span>
        <span className="tag">
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 13.6666C0.733333 13.6666 0.5 13.5666 0.3 13.3666C0.1 13.1666 0 12.9333 0 12.6666V2.33325C0 2.06659 0.1 1.83325 0.3 1.63325C0.5 1.43325 0.733333 1.33325 1 1.33325H2.08333V0.866585C2.08333 0.715474 2.13444 0.588808 2.23667 0.486585C2.33889 0.384363 2.46556 0.333252 2.61667 0.333252C2.7725 0.333252 2.90313 0.384363 3.00855 0.486585C3.11396 0.588808 3.16667 0.715474 3.16667 0.866585V1.33325H8.83333V0.866585C8.83333 0.715474 8.88445 0.588808 8.98667 0.486585C9.08889 0.384363 9.21556 0.333252 9.36667 0.333252C9.5225 0.333252 9.65313 0.384363 9.75855 0.486585C9.86396 0.588808 9.91667 0.715474 9.91667 0.866585V1.33325H11C11.2667 1.33325 11.5 1.43325 11.7 1.63325C11.9 1.83325 12 2.06659 12 2.33325V12.6666C12 12.9333 11.9 13.1666 11.7 13.3666C11.5 13.5666 11.2667 13.6666 11 13.6666H1ZM1 12.6666H11V5.49992H1V12.6666ZM6 8.33325C5.81111 8.33325 5.65278 8.26936 5.525 8.14158C5.39722 8.01381 5.33333 7.85547 5.33333 7.66658C5.33333 7.4777 5.39722 7.31936 5.525 7.19159C5.65278 7.06381 5.81111 6.99992 6 6.99992C6.18889 6.99992 6.34722 7.06381 6.475 7.19159C6.60278 7.31936 6.66667 7.4777 6.66667 7.66658C6.66667 7.85547 6.60278 8.01381 6.475 8.14158C6.34722 8.26936 6.18889 8.33325 6 8.33325ZM3.33333 8.33325C3.14444 8.33325 2.98611 8.26936 2.85833 8.14158C2.73056 8.01381 2.66667 7.85547 2.66667 7.66658C2.66667 7.4777 2.73056 7.31936 2.85833 7.19159C2.98611 7.06381 3.14444 6.99992 3.33333 6.99992C3.52222 6.99992 3.68056 7.06381 3.80833 7.19159C3.93611 7.31936 4 7.4777 4 7.66658C4 7.85547 3.93611 8.01381 3.80833 8.14158C3.68056 8.26936 3.52222 8.33325 3.33333 8.33325ZM8.66667 8.33325C8.47778 8.33325 8.31944 8.26936 8.19167 8.14158C8.06389 8.01381 8 7.85547 8 7.66658C8 7.4777 8.06389 7.31936 8.19167 7.19159C8.31944 7.06381 8.47778 6.99992 8.66667 6.99992C8.85556 6.99992 9.01389 7.06381 9.14167 7.19159C9.26944 7.31936 9.33333 7.4777 9.33333 7.66658C9.33333 7.85547 9.26944 8.01381 9.14167 8.14158C9.01389 8.26936 8.85556 8.33325 8.66667 8.33325ZM6 10.9999C5.81111 10.9999 5.65278 10.936 5.525 10.8083C5.39722 10.6805 5.33333 10.5221 5.33333 10.3333C5.33333 10.1444 5.39722 9.98603 5.525 9.85825C5.65278 9.73047 5.81111 9.66658 6 9.66658C6.18889 9.66658 6.34722 9.73047 6.475 9.85825C6.60278 9.98603 6.66667 10.1444 6.66667 10.3333C6.66667 10.5221 6.60278 10.6805 6.475 10.8083C6.34722 10.936 6.18889 10.9999 6 10.9999ZM3.33333 10.9999C3.14444 10.9999 2.98611 10.936 2.85833 10.8083C2.73056 10.6805 2.66667 10.5221 2.66667 10.3333C2.66667 10.1444 2.73056 9.98603 2.85833 9.85825C2.98611 9.73047 3.14444 9.66658 3.33333 9.66658C3.52222 9.66658 3.68056 9.73047 3.80833 9.85825C3.93611 9.98603 4 10.1444 4 10.3333C4 10.5221 3.93611 10.6805 3.80833 10.8083C3.68056 10.936 3.52222 10.9999 3.33333 10.9999ZM8.66667 10.9999C8.47778 10.9999 8.31944 10.936 8.19167 10.8083C8.06389 10.6805 8 10.5221 8 10.3333C8 10.1444 8.06389 9.98603 8.19167 9.85825C8.31944 9.73047 8.47778 9.66658 8.66667 9.66658C8.85556 9.66658 9.01389 9.73047 9.14167 9.85825C9.26944 9.98603 9.33333 10.1444 9.33333 10.3333C9.33333 10.5221 9.26944 10.6805 9.14167 10.8083C9.01389 10.936 8.85556 10.9999 8.66667 10.9999Z"
              fill="#888888"
            />
          </svg>
          Período: Últimos 15 dias
        </span>
      </div>
      {infos ? <CardGrid infos={infos} /> : <BarLoader color={"#0F79B2"} width={"100%"} />}
    </Modal>
  );
};

const mapStateToProps = (store) => ({
  paciente: store.adesao.paciente,
  nome: store.informacaopessoal.nome,
});

export default connect(mapStateToProps, null)(RaioXModal);
